import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class PropertyReconciliationResource extends BaseResource {
  constructor() {
    super({ url: '/api/properties/reconciliations' });
  }

  search(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/search${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
